module.exports={turnstile_modal:{message:"Verificando detalhes de segurança"}};